import Tooltip from './Tooltip'
import VerifyInput from './VerifyInput'
import Input from './Input'
import Modal from './Modal'
import Loading from './Loading'
import Header from './Header'
import Pagination from './Pagination'

import Password from './Password.vue'

const compts = [
  Tooltip,
  Modal,
  Loading
]
export {
  Tooltip,
  VerifyInput,
  Input,
  Modal,
  Loading,
  Header,
  Pagination,
  Password
}


export default {
  install: function(vm){
    
    compts.forEach(element => {
      if(element.install){
        element.install(vm)
      }
    });
  }
}
